module.exports = __webpack_public_path__ + "static/img/intro.5ed7353e.png";